export default "__VITE_ASSET__BTgE910a__"